import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function TravelResults() {
  const nav = useNavigate();
  const loc = useLocation() as any;
  const offers = loc?.state?.offers || [];
  const search = loc?.state?.search || {};
  const tenor = 12;

  if (!offers.length) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center p-6">
          <h2 className="text-xl font-semibold text-foreground mb-2">No Results Found</h2>
          <p className="text-muted-foreground mb-4">Go back and search again.</p>
          <button 
            onClick={() => nav(-1)}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 smooth-transition"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-5xl mx-auto p-6">
        <h2 className="text-xl font-heading font-semibold mb-4 text-flexaura-navy">
          Results: {search.origin} → {search.destination}
        </h2>

        <div className="grid gap-4">
          {offers.map((o: any) => {
            const total = Number(o?.total_amount) || Number(o?.total || 0);
            const monthly = Math.ceil(total / tenor);
            return (
              <div 
                key={o.id} 
                className="border border-border rounded-2xl p-4 card-shadow bg-card flex flex-col md:flex-row md:items-center md:justify-between smooth-transition hover:elevated-shadow"
              >
                <div>
                  <div className="text-lg font-medium text-flexaura-navy">
                    AED {total.toLocaleString()}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {o?.slices?.map((s: any, i: number) => (
                      <span key={i}>
                        {s?.origin?.iata_code} → {s?.destination?.iata_code} 
                        {i < o.slices.length - 1 ? " • " : ""}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center gap-3 mt-3 md:mt-0">
                  <span className="text-sm px-3 py-1 rounded-full text-white gradient-bg">
                    From AED {monthly}/mo
                  </span>
                  <button
                    onClick={() => nav("/travel/passenger-details", { state: { offer: o, search } })}
                    className="px-5 py-2 rounded-2xl text-white font-medium bg-flexaura-navy hover:bg-flexaura-navy/90 smooth-transition"
                  >
                    Select
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}